<template>
    <div>
        <label>{{$t('contacts.addModal.emailAddress')}}</label>
        <form @submit.prevent="sendEmail">
            <div class="row mb-3">
                <div class="col-lg-9">
                    <b-form-input
                            type="email"
                            id="email"
                            v-model="email"
                            :placeholder="$t('contacts.addModal.emailAddressPlaceholder')"
                    />
                </div>
                <div class="col-lg-3 mt-3 mt-lg-0">
                    <b-btn
                            type="submit"
                            variant="primary"
                            :block="true"
                            :disabled="loading||!email"
                    >{{ $t('contacts.addModal.emailSubmit') }}
                    </b-btn>
                </div>
            </div>
        </form>
    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import VueQRCodeGenerator from 'vue-qrcode-component';
import {validateEmail} from '../../helper';

export default {
    components: {'qr-code': VueQRCodeGenerator},
    data: function () {
        return {
            email: null,
        };
    },
    computed: mapGetters({
        loading: 'loading/loading/loading',
        token: 'contact/pair/token',
    }),
    methods: {
        validateEmail,
        getToken: function (force = false) {
            this.$store.dispatch('contact/pair/getToken', force);
        },
        sendEmail: function () {
            if (!this.validateEmail(this.email)) {
                this.$notify.error(this.$t('passwordRecovery.error.wrongEmail'));
                return null;
            }
            const uri =
                location.origin +
                '/' +
                this.$router.resolve({
                    name: 'ContactAddURLEmail',
                    params: {token: '__token__'},
                }).href;
            this.$store
                .dispatch('contact/pair/sendEmail', {
                    token: this.token,
                    uri: uri,
                    email: this.email,
                })
                .then(() => {
                    this.$notify.success(this.$t('contacts.addModal.emailSendSuccess'));
                });
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/contact/PairEmail.vue